import { paths } from "@rms-types/constants/paths";
import { lazy } from "react";

import { AppRoute } from "@/routes/types";

export const messageRoutes: AppRoute[] = [
  {
    path: paths.app.messages.inbox.path,
    page: lazy(() =>
      import("@/features/conversation/layouts/inbox").then((module) => ({
        default: module.ConversationInboxSidebarLayout,
      }))
    ),
    permissions: paths.app.messages.permissions,
    children: [
      {
        path: paths.app.messages.inbox.conversation.path,
        page: lazy(() =>
          import("@/layouts/content-layout").then((module) => ({
            default: module.ContentLayout,
          }))
        ),
        permissions: paths.app.messages.inbox.conversation.permissions,
        children: [
          {
            index: true,
            page: lazy(() =>
              import("@/pages/messages/inbox/conversation").then((module) => ({
                default: module.MessagesInboxConversationRoot,
              }))
            ),
            permissions: paths.app.messages.inbox.conversation.permissions,
          },
          {
            path: paths.app.messages.inbox.conversation.details.path,
            page: lazy(() =>
              import("@/pages/messages/inbox/conversation/conversationId").then((module) => ({
                default: module.MessagesInboxConversation,
              }))
            ),
            permissions: paths.app.messages.inbox.conversation.details.permissions,
          },
        ],
      },
    ],
  },
  {
    path: paths.app.messages.favorites.path,
    page: lazy(() =>
      import("@/features/conversation/layouts/favorites").then((module) => ({
        default: module.ConversationFavoritesSidebarLayout,
      }))
    ),
    permissions: paths.app.messages.permissions,
    children: [
      {
        path: paths.app.messages.favorites.conversation.path,
        page: lazy(() =>
          import("@/layouts/content-layout").then((module) => ({
            default: module.ContentLayout,
          }))
        ),
        permissions: paths.app.messages.favorites.conversation.permissions,
        children: [
          {
            index: true,
            page: lazy(() =>
              import("@/pages/messages/favorites/conversation").then((module) => ({
                default: module.MessagesFavoritesConversationRoot,
              }))
            ),
            permissions: paths.app.messages.favorites.conversation.permissions,
          },
          {
            path: paths.app.messages.favorites.conversation.details.path,
            page: lazy(() =>
              import("@/pages/messages/favorites/conversation/conversationId").then((module) => ({
                default: module.MessagesFavoritesConversation,
              }))
            ),
            permissions: paths.app.messages.favorites.conversation.details.permissions,
          },
        ],
      },
    ],
  },
  {
    path: paths.app.messages.trash.path,
    page: lazy(() =>
      import("@/features/conversation/layouts/trash").then((module) => ({
        default: module.ConversationTrashSidebarLayout,
      }))
    ),
    permissions: paths.app.messages.permissions,
    children: [
      {
        path: paths.app.messages.trash.conversation.path,
        page: lazy(() =>
          import("@/layouts/content-layout").then((module) => ({
            default: module.ContentLayout,
          }))
        ),
        permissions: paths.app.messages.trash.conversation.permissions,
        children: [
          {
            index: true,
            page: lazy(() =>
              import("@/pages/messages/trash/conversation").then((module) => ({
                default: module.MessagesTrashConversationRoot,
              }))
            ),
            permissions: paths.app.messages.trash.conversation.permissions,
          },
          {
            path: paths.app.messages.trash.conversation.details.path,
            page: lazy(() =>
              import("@/pages/messages/trash/conversation/conversationId").then((module) => ({
                default: module.MessagesTrashConversation,
              }))
            ),
            permissions: paths.app.messages.trash.conversation.details.permissions,
          },
        ],
      },
    ],
  },
  {
    path: paths.app.messages.folder.path,
    page: lazy(() =>
      import("@/features/conversation/layouts/folder").then((module) => ({
        default: module.ConversationFolderSidebarLayout,
      }))
    ),
    permissions: paths.app.messages.permissions,
    children: [
      {
        path: paths.app.messages.folder.details.path,
        page: lazy(() =>
          import("@/features/conversation/layouts/folder/folderId").then((module) => ({
            default: module.ConversationFolderIdSidebarLayout,
          }))
        ),
        permissions: paths.app.messages.folder.details.permissions,
        children: [
          {
            path: paths.app.messages.folder.details.conversation.path,
            page: lazy(() =>
              import("@/layouts/content-layout").then((module) => ({
                default: module.ContentLayout,
              }))
            ),
            permissions: paths.app.messages.folder.details.permissions,
            children: [
              {
                page: lazy(() =>
                  import("@/pages/messages/folder/folderId/conversation").then((module) => ({
                    default: module.MessagesFolderConversationRoot,
                  }))
                ),
                index: true,
                permissions: paths.app.messages.folder.details.conversation.permissions,
              },
              {
                path: paths.app.messages.folder.details.conversation.details.path,
                page: lazy(() =>
                  import("@/pages/messages/folder/folderId/conversation/conversationId").then((module) => ({
                    default: module.MessagesFolderConversation,
                  }))
                ),
                permissions: paths.app.messages.folder.details.conversation.details.permissions,
              },
            ],
          },
        ],
      },
    ],
  },
];
